export default __webpack_public_path__ + "static/media/flag.bca4c3c0.svg";